import { LoaderService } from '@/app/common/services/loader/loader.service'
import { ChecklistHeaderService } from '@/app/modules/checklist-header/core/service'
import { ChecklistHeader, StatusEnum } from '@/app/modules/checklist-header/core/type'
import { CommonModule } from '@angular/common'
import { Component, EventEmitter, inject, Output } from '@angular/core'
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzFormModule } from 'ng-zorro-antd/form'
import { NzInputModule } from 'ng-zorro-antd/input'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'app-not-proceed',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    ReactiveFormsModule,
    FormsModule,
    NzFormModule,
    NzInputModule,
    NzModalModule
  ],
  templateUrl: './not-proceed.component.html',
  styleUrl: './not-proceed.component.scss'
})
export class NotProceedComponent {
  @Output() onNotProceed = new EventEmitter<boolean>()

  loader = new BehaviorSubject<boolean>(false)

  private loaderService = inject(LoaderService)
  private notification = inject(NzNotificationService)
  private checklistHeaderService = inject(ChecklistHeaderService)

  data!: ChecklistHeader

  isVisible = false

  notProceedForm = new FormGroup({
    maintenance_observation: new FormControl<string>('', [Validators.required, Validators.minLength(3)])
  })

  handleOpen(data: ChecklistHeader) {
    this.data = data
    if (data) {
      this.isVisible = true
      this.notProceedForm.reset()
    }
  }

  onSubmit() {
    if (this.notProceedForm.valid) {
      this.loader.next(true)
      const { maintenance_observation } = this.notProceedForm.value

      this.loaderService
        .executeWithLoader(
          this.checklistHeaderService.update(this.data.id, {
            status: StatusEnum.NOT_PROCEED,
            maintenance_observation: maintenance_observation as string
          })
        )
        .subscribe({
          next: () => {
            this.loader.next(false)
            this.notification.success('Sucesso', 'Checklist marcado como não procede!')
            this.isVisible = false
            this.onNotProceed.emit(true)
          },
          error: () => {
            this.loader.next(false)
            this.notification.error('Erro', 'Não foi possível registrar o motivo!')
          }
        })
    } else {
      this.notification.warning('Atenção', 'Informe o motivo pelo qual não procede.')
    }
  }

  handleCancel() {
    this.isVisible = false
  }
}
